class ProductNavigation extends HTMLElement {
  constructor() {
    super();

    this.handleScroll = this.handleScroll.bind(this);
    this.update = this.update.bind(this);
    this.handleChangeLink = this.handleChangeLink.bind(this);
    this.handleBackInStockJump = this.handleBackInStockJump.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);

    this.triggerEl = null;
    this.frame = null;
  }

  connectedCallback() {
    this.triggerEl =
      document.querySelector('.product__info-wrapper .product-form__submit-watcher') ||
      document.querySelector('.product__info-wrapper .trigger-back-in-stock-btn');

    this.addEventListener('click', this.handleChangeLink);
    this.addEventListener('click', this.handleBackInStockJump);
    this.productInfo = this.closest('product-info');
    this.productInfo?.addEventListener('input', this.handleQuantityChange);
    this.productInfo?.addEventListener('change', this.handleQuantityChange);
    if (this.productInfo) {
      this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.handleScroll);
    }
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });
    if (this.triggerEl) {
      this.observer = new IntersectionObserver(this.handleScroll);
      this.observer.observe(this.triggerEl);
    }
    this.update();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleChangeLink);
    this.removeEventListener('click', this.handleBackInStockJump);
    this.productInfo?.removeEventListener('input', this.handleQuantityChange);
    this.productInfo?.removeEventListener('change', this.handleQuantityChange);
    this.quantityUnsubscribe?.();
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  handleScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(this.update);
  }

  update() {
    this.frame = null;
    this.classList.toggle('is-active', this.isTriggerOutsideViewport());
    this.toggleAttribute('inert', !this.classList.contains('is-active'));
    this.syncQuantity();
  }

  handleQuantityChange(event) {
    const inline = this.productInfo.querySelector('.product-form__quantity [name="quantity"]');
    const sticky = this.querySelector('[name="quantity"]');
    if (!inline || !sticky) return;
    if (event.target === sticky) {
      inline.value = sticky.value;
      inline.dispatchEvent(new Event(event.type, { bubbles: true }));
    }
    this.handleScroll();
  }

  syncQuantity() {
    const inline = this.productInfo?.querySelector('.product-form__quantity [name="quantity"]');
    const sticky = this.querySelector('[name="quantity"]');
    if (!inline || !sticky) return;
    ['min', 'max', 'step', 'data-min', 'data-max', 'data-cart-quantity', 'aria-label', 'disabled'].forEach((attribute) => {
      const value = inline.getAttribute(attribute);
      if (sticky.getAttribute(attribute) === value) return;
      if (value === null) sticky.removeAttribute(attribute);
      else sticky.setAttribute(attribute, value);
    });
    sticky.value = inline.value;
    sticky.closest('quantity-input').validateQtyRules?.();
  }

  isTriggerOutsideViewport() {
    if (!this.triggerEl?.getClientRects().length) return false;
    const header = document.querySelector('.shopify-section-header-sticky');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    const { top, bottom } = this.triggerEl.getBoundingClientRect();
    return bottom <= Math.max(headerBottom, 0) || top >= window.innerHeight;
  }

  handleChangeLink(event) {
    const link = event.target.closest('.sticky-atc__change-link');
    if (!link) return;
    event.preventDefault();
    const target = document.querySelector(link.hash);
    const scrollTarget = target?.closest('.product--playmat') || target;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (scrollTarget) scrollTarget.scrollIntoView({ behavior });
  }

  handleBackInStockJump(event) {
    const button = event.target.closest('.back-in-stock__jump');
    const emailInput = button && document.getElementById(button.dataset.target);
    if (!emailInput) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    window.scrollTo({ top: this.centeredScrollTop(emailInput), behavior });
    emailInput.focus({ preventScroll: true });
  }

  centeredScrollTop(element) {
    const { scrollY } = window;
    element.closest('.product--playmat')?.scrollIntoView({ behavior: 'instant' });
    const { top, height } = element.getBoundingClientRect();
    const centeredTop = window.scrollY + top - (window.innerHeight - height) / 2;
    window.scrollTo({ top: scrollY, behavior: 'instant' });
    return centeredTop;
  }
}

customElements.define('product-navigation', ProductNavigation);
